<template>
    <div class="d-flex mt-6">
        <v-btn
            v-show="hideSteps"
            v-if="value > 0"
            :color="color"
            class="white--text mr-10"
            outlined
            large
            rounded
            @click="prev()"
        >
            <v-icon left size="24px" class="mr-5">mdi-arrow-left</v-icon>
            {{ t('consultants::button.prev_step') }}
        </v-btn>
        <slot> </slot>
        <v-btn
            v-show="hideSteps"
            v-if="!last"
            :color="color"
            class="white--text"
            large
            rounded
            :disabled="isDisabled"
            @click="next()"
        >
            {{ t('consultants::button.next_step') }}
            <v-icon right size="24px" class="ml-5">mdi-arrow-right</v-icon>
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'StepperControl',
    props: {
        value: {
            type: Number,
            default: 0,
            required: false,
        },
        last: {
            type: Boolean,
            default: false,
            required: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
            required: false,
        },
        hideSteps: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    data() {
        return {
            color: 'primary',
        };
    },
    methods: {
        next() {
            this.$emit('input', parseInt(this.value) + 1);
        },
        prev() {
            this.$emit('input', parseInt(this.value) - 1);
        },
    },
};
</script>

<style scoped>
.v-btn.v-btn--disabled.v-btn--has-bg {
    /* background-color: rgba(215, 174, 85, 0.4) !important; */
}
.v-btn.v-btn--disabled .v-icon,
.v-btn.v-btn--disabled {
    color: rgba(255, 255, 255, 0.8) !important;
}
</style>
